import ProductType from "types/enums/ProductType"
import SensorTypeCode from "types/enums/SensorTypeCode"

const SENSOR_TYPE_TO_PRODUCT_TYPE: Record<number, ProductType> = {
  [SensorTypeCode.THS]: ProductType.THS,
  [SensorTypeCode.WLS]: ProductType.WLS,
}

export const getSensorProductType = (typeCode: number): ProductType | undefined => SENSOR_TYPE_TO_PRODUCT_TYPE[typeCode]
